import React, { useState } from 'react';
import { CircularProgress, IconButton, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ScrollBox from '../../../components/ScrollBox';
import { CloudUpload, InsertDriveFile } from '@mui/icons-material';
import { makeTxtOverFLow } from '../../../utils/format';
import { fileUploadService, getFileUrl } from '../../../services/s3-service';
import { notify } from '../../../components/notify';

function AttachSection({ filesArr, onUpload, onRemove }) {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);

    async function handleFileUpload(e) {
        setLoading(true);
        const files = Array.from(e.target.files);
        try {
            const uploadedFiles = [];
            for (const file of files) {
                const fileKey = await fileUploadService(file);
                const imgUrl = await getFileUrl({ fileKey });
                uploadedFiles.push({ fileKey, fileUrl: imgUrl, fileName: file.name });
            }
            onUpload(uploadedFiles);
        } catch (error) {
            console.log(error);
            if (error === "apiError")
                notify("error", "Error in File Uploading...");
            onUpload(files.map(() => ({ fileKey: null, fileUrl: null, fileName: null })));
        }

        setLoading(false);
    }


    return (
        <Stack>
            <Stack direction={'row'} alignItems='center' >
                <Typography sx={{ fontSize: 13, fontWeight: 500, color: "rgba(0, 0, 0, 0.8)" }}>Attachments</Typography>
                {loading ? <IconButton>
                    <CircularProgress size={10} color={"primary"} />
                </IconButton> : <IconButton component="label">
                    <CloudUpload sx={{ color: theme.palette.custom.btn }} />
                    <input type="file" multiple hidden onChange={handleFileUpload} />
                </IconButton>}
            </Stack>

            <ScrollBox height={200} width={300} pr={4}>
                {filesArr.map((i, index) => (
                    <Stack direction={"row"} alignItems={"center"} gap={1} key={index} justifyContent={"center"}
                        sx={{ height: 30, width: 240, border: 1, borderColor: "rgba(0,0,0,0.5)", borderRadius: 4, mb: 1, bgcolor: "rgba(162, 214, 249, 0.18)" }} >
                        <InsertDriveFile sx={{ color: "red" }} />
                        <Stack width={140} alignItems={"center"}>
                            <Tooltip title={i.fileName}>
                                <Typography sx={{ fontSize: 12, color: "rgba(0,0,0,0.8)" }} >{makeTxtOverFLow(i.fileName, 17)}</Typography>
                            </Tooltip>
                        </Stack>
                        <IconButton size="small" aria-label="Remove file" onClick={() => onRemove(index)}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Stack>
                ))}
            </ScrollBox>
        </Stack>
    );
};



export default AttachSection;